var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62 1H38a1 1 0 0 0-1 1v32a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm-1 32H39V3h22zM60 38H34c-1.654 0-3 1.346-3 3v19c0 1.654 1.346 3 3 3h26c1.654 0 3-1.346 3-3V41c0-1.654-1.346-3-3-3zm1 22c0 .551-.448 1-1 1H34c-.552 0-1-.449-1-1V41c0-.551.448-1 1-1h26c.552 0 1 .449 1 1z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 56h-2a1 1 0 1 0-2 0H37c-1.324 0-1.323 2 0 2h16a1 1 0 1 0 2 0h2c1.324 0 1.323-2 0-2zM33 31V7c0-1.654-1.346-3-3-3H4C2.346 4 1 5.346 1 7v24c0 1.654 1.346 3 3 3h26c1.654 0 3-1.346 3-3zm-2 0c0 .551-.448 1-1 1H4c-.552 0-1-.449-1-1V7c0-.551.448-1 1-1h26c.552 0 1 .449 1 1z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM24.707 20.293a.999.999 0 0 0-1.414 0L20 23.586l-6.293-6.293a.999.999 0 0 0-1.414 0l-7 7c-.936.936.479 2.349 1.414 1.414L13 19.414l6.293 6.293a.999.999 0 0 0 1.414 0L24 22.414l3.293 3.293c.922.922 2.362-.467 1.414-1.414zM43 8h10c1.324 0 1.323-2 0-2H43c-1.324 0-1.323 2 0 2zM43 17h14c1.324 0 1.323-2 0-2H43c-1.324 0-1.323 2 0 2zM43 26h14c1.324 0 1.323-2 0-2H43c-1.324 0-1.323 2 0 2zM43 30h5c1.324 0 1.323-2 0-2h-5c-1.324 0-1.323 2 0 2zM43 13h2c1.324 0 1.323-2 0-2h-2c-1.324 0-1.323 2 0 2zM50 13h7c1.324 0 1.323-2 0-2h-7c-1.324 0-1.323 2 0 2zM43 22h7c1.324 0 1.323-2 0-2h-7c-1.324 0-1.323 2 0 2zM57 20h-2c-1.324 0-1.323 2 0 2h2c1.324 0 1.323-2 0-2zM15 37C7.28 37 1 41.935 1 48c0 2.469 1.062 4.874 3 6.814V62c0 .896 1.083 1.331 1.707.707l4.399-4.399c1.544.46 3.188.692 4.894.692 7.72 0 14-4.935 14-11s-6.28-11-14-11zm0 20c-1.709 0-3.339-.261-4.847-.776a.996.996 0 0 0-1.03.239L6 59.586V54.39a1 1 0 0 0-.318-.732C3.927 52.026 3 50.069 3 48c0-4.962 5.383-9 12-9s12 4.038 12 9-5.383 9-12 9z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 48,
    r: 1.5,
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 48,
    r: 1.5,
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 48,
    r: 1.5,
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.262 53.714 6.647-3.83c1.448-.833 1.448-2.93 0-3.764l-6.646-3.828c-1.444-.836-3.263.213-3.263 1.881v7.658c0 1.69 1.835 2.702 3.262 1.883zM44 44.173c0-.129.146-.217.264-.148l6.647 3.829a.172.172 0 0 1 0 .297l-6.646 3.829c-.118.066-.265-.015-.265-.148z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/social-media.26deb4a2aa42d9830357d843f2206730.svg";
export { ForwardRef as ReactComponent };